// src/components/About.js
import React from "react";
import { motion } from "framer-motion";

const About = () => (
  <motion.section
    className="section"
    id="about"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
  >
    <h2>About CropBots</h2>
    <p>
      CropBots is an agri-tech startup designing smart, autonomous robots that support both indoor and open-field farming. We specialize in robotic solutions for tasks such as spraying, weed control, harvesting, and load carrying.
    </p>
  </motion.section>
);

export default About;
